import { PropsWithChildren, createContext, useState } from 'react'
import { IUserData } from '../../utils/types/common'

export const UserDataContext = createContext({} as any)

interface IUserDataProviderProps extends PropsWithChildren<any> {}

export const UserDataProvider: React.FC<IUserDataProviderProps> = ({
    children,
}) => {
    const [userData, setUserData] = useState<IUserData | {}>({})

    return (
        <UserDataContext.Provider value={{ userData, setUserData }}>
            {children}
        </UserDataContext.Provider>
    )
}
